<script setup lang="ts">
import Layout from "./Layout.vue"

defineOptions({ layout: Layout })

const props = defineProps<{
  knowledge_base: PublicKBKnowledgeBase
  selected_article: PublicKBArticle
  toc_links: Array<{ id: string; title: string; level: number }>
  category: PublicKBCategory
}>()

const { t } = useTranslate()
</script>

<template>
  <PublicKBBreadcrumb :category="category" :article="selected_article" />
  <div class="mt-12 flex justify-between">
    <article class="w-full max-w-3xl">
      <h1 class="mb-2 text-3xl font-bold sm:text-4xl">{{ selected_article.title }}</h1>
      <p class="text-lg text-gray-500">{{ selected_article.subtitle }}</p>
      <div
        class="prose prose-h2:text-2xl prose-h3:text-xl prose-h2:font-semibold prose-h3:font-semibold prose-h2:mt-12 prose-h3:mt-6 prose-h4:text-[15px] prose-p:text-[15px] mt-8 max-w-full"
        v-html="selected_article.html_content"
      ></div>
    </article>

    <template v-if="toc_links">
      <aside class="sticky top-20 hidden h-max max-w-[250px] min-w-[150px] flex-col sm:flex print:hidden">
        <div class="text-gray-500">
          <HUIIcon icon="bars-staggered" variant="regular" class="mr-1" />
          {{ t(".toc") }}
        </div>
        <div class="mt-4 flex flex-col">
          <a
            v-for="link in toc_links"
            :key="link.id"
            class="border-l-3 border-gray-200 px-3 py-1.5 text-gray-500 hover:text-gray-700"
            :class="{ 'pl-7': link.level > 1 }"
            :href="`#${link.id}`"
          >
            {{ link.title }}
          </a>
        </div>
      </aside>
    </template>
  </div>
</template>

<i18n lang="yaml">
de:
  previous: Vorheriger Artikel
  next: Nächster Artikel

  toc: Auf dieser Seite
</i18n>
